import { HelpCircle } from "lucide-react";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "¿Qué tipo de maquinaria y equipos pueden asegurarse?",
    a: "Cubrimos tres grandes categorías: (1) maquinaria agrícola (tractores, cosechadoras, pulverizadoras, arados), (2) maquinaria de construcción y minería (excavadoras, retroexcavadoras, grúas, cargadores frontales, camiones mineros) y (3) equipos electrónicos de uso particular o comercial (computación, celulares, comunicaciones, medición, equipos médicos y otros).",
  },
  {
    q: "¿Qué cubre el seguro de maquinaria agrícola?",
    a: "Cubre los daños físicos de la maquinaria (incendio, robo, colisión, vuelco, entre otros) y la Responsabilidad Civil por daños corporales y/o materiales causados a terceros por el equipo.",
  },
  {
    q: "¿El seguro de construcción y minería cubre a terceros?",
    a: "Sí. Al igual que la maquinaria agrícola, el seguro incluye la Responsabilidad Civil por daños corporales y/o materiales que el equipo cause a terceros en obra o faena.",
  },
  {
    q: "¿Puedo asegurar mi computador o celular?",
    a: "Sí. El seguro de equipos electrónicos cubre equipos particulares o comerciales contra daños físicos (accidentes, robo, incendio y otros riesgos), incluyendo computadores, celulares, equipos de comunicación, medición y equipos médicos.",
  },
  {
    q: "¿Cuánto demora recibir mi propuesta?",
    a: "Apenas completas el formulario, uno de nuestros ejecutivos te contacta rápidamente con una propuesta clara, comparando entre las principales aseguradoras del país.",
  },
  {
    q: "¿Puedo mantener mi aseguradora actual?",
    a: "Sí. Trabajamos con BCI Seguros, SURA, Zurich, Reale, HDI y MAPFRE, por lo que buscamos la mejor alternativa, incluso con tu aseguradora actual si así lo prefieres.",
  },
  {
    q: "¿Tiene algún costo cotizar?",
    a: "No. Cotizar es totalmente gratis y sin compromiso. Solo pagas la prima de la póliza si decides contratar tu seguro con nosotros.",
  },
];

export const Faq = () => {
  return (
    <section id="faq" className="py-12 sm:py-16 bg-gray-50/60 border-t border-gray-100">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-brand-yellow">
            <HelpCircle className="h-4 w-4" /> Preguntas frecuentes
          </p>
          <h2 className="font-display mt-3 text-3xl sm:text-5xl font-bold tracking-tight text-brand-ink">
            Resolvemos tus dudas.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion">
          {FAQS.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-gray-200">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-base sm:text-lg font-semibold text-brand-ink hover:no-underline py-5"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-gray-600 leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};
